import { defineStore } from 'pinia'
import { fetchItems, createItem } from '@/api/ad_scans'
import useCrudStore from '@/hooks/useCrudStore'

export const defaultFilter = {}

export const defaultModel = {
  countries: [],
  desktop: [],
  mobile: [],
  tablet: [],
  platforms: [],
  devices: [],
  browsers: [],
  kind: 0
}

export const useAdScansStore = defineStore('adscans', () => {
  const {
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,
    FetchItems,
    SaveItem,
    SetFilters,
    SetCurrentPage
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    createItem
  })

  return {
    // State
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,

    // Actions
    SetFilters,
    FetchItems,
    SaveItem,
    SetCurrentPage
  }
})
